import makeStyles from '@mui/styles/makeStyles';

const usePrGraphContainerStyles = makeStyles({
  root: {}
});

export default usePrGraphContainerStyles;
